import Styles from './AddChargingTokensModal.module.css'
import Colors from 'Theme/Colors'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { SelectPicker } from 'rsuite'
import InfinityEnums from 'Enums/InfinityEnums'
import CardActions from 'Stores/Card/Actions'
import CardSelectors from 'Stores/Card/Selectors'
import {
  IFModal,
  IFButton,
  IFTextInput,
  IFText,
  IFToastMessage,
} from 'Components'
import React, { useState, useEffect, useRef } from 'react'
import RequestState from 'Enums/RequestState'
import PropTypes from 'prop-types'
import { Divider } from '@mui/material'
import Dropzone from 'react-dropzone'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import { xlsxToJson, csvToJson } from '../../Utils/DataConversion'
import { toaster } from 'rsuite'
import Icon from '@mui/material/Icon'
import CancelIcon from '@mui/icons-material/Cancel'
import AuthSelectors from 'Stores/Auth/Selectors'

const AddChargingTokens = React.forwardRef(
  (
    {
      addChargingTokens,
      addChargingTokensRequestState,
      addChargingTokensBulk,
      operatorUser,
    },
    ref,
  ) => {
    const [contractId, setContractId] = useState('')
    const [huid, setHuid] = useState('')
    const [type, setType] = useState('')
    const [status, setStatus] = useState('')
    const [contractIdError, setContractIdError] = useState('')
    const [uidError, setHuidError] = useState('')
    const [typeError, setTypeError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [uploadedFile, setUploadedFile] = useState(null)
    const [jsonFile, setJsonFile] = useState({})
    const [addedFile, setAddedFile] = useState(false)
    const [typedText, setTypedText] = useState(false)
    const [canContinue, setCanContinue] = useState(false)
    let errorFlag = false

    useEffect(() => {
      if (addChargingTokensRequestState === RequestState.SUCCEEDED) {
        ref.current.dismiss()
      }
    }, [addChargingTokensRequestState])

    const { t } = useTranslation()

    const typeEnum = Object.values(InfinityEnums.ChargingTokenType)
    const statusEnum = Object.values(InfinityEnums.ChargingTokenStatus)

    const typeOptions = []
    for (const index in typeEnum) {
      typeOptions.push({
        label: (
          <IFText style={{ color: Colors.text }}>{typeEnum[index]}</IFText>
        ),
        value: typeEnum[index],
      })
    }

    const statusOptions = []
    for (const index in statusEnum) {
      if (statusEnum[index] !== InfinityEnums.ChargingTokenStatus.DEACTIVATED) {
        statusOptions.push({
          label: (
            <IFText style={{ color: Colors.text }}>{statusEnum[index]}</IFText>
          ),
          value: statusEnum[index],
        })
      }
    }

    const resetErrors = () => {
      setContractIdError('')
      setHuidError('')
      setTypeError('')
      setStatusError('')
    }

    const handleModalClose = () => {
      setContractId('')
      setHuid('')
      setType('')
      setStatus('')
      resetErrors()
      setAddedFile(false)
      setTypedText(false)
      setUploadedFile(null)
      setCanContinue(false)
    }

    const handleXlsx = (file) => {
      const json = xlsxToJson(file)
      json.then((data) => setJsonFile(data))
    }

    const handleCsv = (file) => {
      const json = csvToJson(file)
      json.then((parsedFile) => setJsonFile(parsedFile.data))
    }

    const handleOnDrop = (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        if (acceptedFiles[0].name.includes('csv')) {
          handleCsv(acceptedFiles[0])
          setCanContinue(true)
        } else if (acceptedFiles[0].name.includes('xlsx')) {
          handleXlsx(acceptedFiles[0])
          setCanContinue(true)
        } else {
          toaster.push(
            <IFToastMessage
              type={'error'}
              text={t('AddChargingTokensModal.FileNotSupported')}
            />,
            { placement: 'topEnd' },
          )
          errorFlag = true
        }
        setUploadedFile(acceptedFiles)
        setAddedFile(true)

        resetErrors()
      }
    }

    const handleSubmit = () => {
      if (typedText) {
        const data = {
          contractId: contractId,
          huid: huid,
          type: type,
          status: status,
          operator: operatorUser.operator,
        }
        addChargingTokens(data)
      } else if (addedFile && !errorFlag) {
        // TODO: fix
        const data = {
          chargingTokens: jsonFile,
        }

        addChargingTokensBulk(data)
      } else errorFlag = false
    }

    const typePickerRef = useRef()
    const statusPickerRef = useRef()

    return (
      <IFModal
        onDismiss={handleModalClose}
        title={t('AddChargingTokensModal.AddNewCard')}
        ref={ref}
        style={{ borderRadius: 5 }}
      >
        <div className={Styles.InputWrapperLeft}>
          <div
            className={[
              Styles.EmailDivShow,
              Styles.AnimateDropZoneHeightIn,
            ].join(' ')}
          >
            <div className={addedFile ? Styles.FadeOut : Styles.FadeIn}>
              <div className={Styles.RowContainer}>
                <div className={Styles.InputContainer}>
                  <IFText className={Styles.Label}>
                    {t('AddChargingTokensModal.ContractID')}
                  </IFText>
                  <IFTextInput
                    style={{ caretColor: Colors.primary }}
                    className={Styles.Input}
                    isFixed={true}
                    value={contractId}
                    name="contractID"
                    type="text"
                    onChange={(e) => {
                      setContractId(e.target.value)
                      if (
                        e.target.value.length > 0 ||
                        huid.length > 0 ||
                        type.length > 0 ||
                        status.length > 0
                      ) {
                        setTypedText(true)
                      } else setTypedText(false)
                      if (contractIdError.length > 0) {
                        e.target.value.length === 0
                          ? setContractIdError(
                              t('AddChargingTokensModal.Required'),
                            )
                          : setContractIdError('')
                      }
                      const submit =
                        e.target.value.length > 0 &&
                        huid.length > 0 &&
                        type.length > 0 &&
                        status.length > 0
                      setCanContinue(submit)
                    }}
                    onBlur={(e) => {
                      e.target.value.length === 0
                        ? setContractIdError(
                            t('AddChargingTokensModal.Required'),
                          )
                        : setContractIdError('')
                      const submit =
                        e.target.value.length > 0 &&
                        huid.length > 0 &&
                        type.length > 0 &&
                        status.length > 0
                      setCanContinue(submit)
                    }}
                    {...(contractIdError.length > 0
                      ? { errorText: contractIdError }
                      : {})}
                  />
                  <div style={{ height: '0.6rem' }} />
                </div>
                <div className={Styles.SelectPickerContainer}>
                  <IFText className={Styles.Label}>
                    {t('AddChargingTokensModal.Status')}
                  </IFText>
                  <div
                    ref={statusPickerRef}
                    className={Styles.wrapperContainer}
                  >
                    <div className={Styles.container}>
                      <SelectPicker
                        container={() => statusPickerRef?.current}
                        menuStyle={{ color: Colors.text, zIndex: 1500 }}
                        appearance="default"
                        searchable={false}
                        cleanable={true}
                        value={status}
                        onSelect={(value) => {
                          setStatus(value)
                          if (
                            contractId.length > 0 ||
                            huid.length > 0 ||
                            type.length > 0 ||
                            value.length > 0
                          ) {
                            setTypedText(true)
                          } else setTypedText(false)
                          value.length === 0
                            ? setStatusError(
                                t('AddChargingTokensModal.Required'),
                              )
                            : setStatusError('')
                          const submit =
                            contractId.length > 0 &&
                            huid.length > 0 &&
                            type.length > 0 &&
                            value.length > 0

                          setCanContinue(submit)
                        }}
                        onOpen={() => {
                          status.length === 0
                            ? setStatusError(
                                t('AddChargingTokensModal.Required'),
                              )
                            : setStatusError('')
                        }}
                        data={statusOptions}
                        size="md"
                        onClean={() => {
                          setStatus('')
                          setCanContinue(false)
                          if (
                            contractId.length === 0 &&
                            huid.length === 0 &&
                            type.length === 0
                          ) {
                            setTypedText(false)
                          }
                        }}
                      />
                      <div
                        style={{ color: Colors.red }}
                        className={Styles.ErrorStyling}
                      >
                        {statusError.length > 0 ? (
                          <IFText style={{ fontSize: '0.75rem' }}>
                            {statusError}
                          </IFText>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={Styles.RowContainerMiddle}>
                <div className={Styles.InputContainer}>
                  <IFText className={Styles.Label}>
                    {t('AddChargingTokensModal.Serial')}
                  </IFText>
                  <IFTextInput
                    style={{ caretColor: Colors.primary }}
                    className={Styles.Input}
                    isFixed={true}
                    value={huid}
                    name="huid"
                    type="text"
                    onChange={(e) => {
                      setHuid(e.target.value)
                      if (
                        contractId.length > 0 ||
                        e.target.value.length > 0 ||
                        type.length > 0 ||
                        status.length > 0
                      ) {
                        setTypedText(true)
                      } else setTypedText(false)
                      if (uidError.length > 0) {
                        e.target.value.length === 0
                          ? setHuidError(t('AddChargingTokensModal.Required'))
                          : setHuidError('')
                      }
                      const submit =
                        contractId.length > 0 &&
                        e.target.value.length > 0 &&
                        type.length > 0 &&
                        status.length > 0

                      setCanContinue(submit)
                    }}
                    onBlur={(e) => {
                      e.target.value.length === 0
                        ? setHuidError(t('AddChargingTokensModal.Required'))
                        : setHuidError('')

                      const submit =
                        contractId.length > 0 &&
                        e.target.value.length > 0 &&
                        type.length > 0 &&
                        status.length > 0

                      setCanContinue(submit)
                    }}
                    {...(uidError.length > 0 ? { errorText: uidError } : {})}
                  />
                  <div style={{ height: '0.6rem' }} />
                </div>
                <div className={Styles.SelectPickerContainer}>
                  <IFText className={Styles.Label}>
                    {t('AddChargingTokensModal.Type')}
                  </IFText>
                  <div ref={typePickerRef} className={Styles.wrapperContainer}>
                    <div className={Styles.container}>
                      <SelectPicker
                        container={() => typePickerRef?.current}
                        className={Styles.TypePickerWrapper}
                        menuStyle={{
                          color: Colors.text,
                          zIndex: 1500,
                        }}
                        appearance="default"
                        searchable={false}
                        cleanable={true}
                        value={type}
                        onSelect={(value) => {
                          setType(value)
                          if (
                            contractId.length > 0 ||
                            huid.length > 0 ||
                            value.length > 0 ||
                            status.length > 0
                          ) {
                            setTypedText(true)
                          } else setTypedText(false)
                          value.length === 0
                            ? setTypeError(t('AddChargingTokensModal.Required'))
                            : setTypeError('')
                          const submit =
                            contractId.length > 0 &&
                            huid.length > 0 &&
                            value.length > 0 &&
                            status.length > 0

                          setCanContinue(submit)
                        }}
                        onOpen={() => {
                          type.length === 0
                            ? setTypeError(t('AddChargingTokensModal.Required'))
                            : setTypeError('')
                        }}
                        data={typeOptions}
                        size="md"
                        onClean={() => {
                          setType('')
                          setCanContinue(false)
                          if (
                            contractId.length === 0 &&
                            huid.length === 0 &&
                            status.length === 0
                          ) {
                            setTypedText(false)
                          }
                        }}
                      />
                      <div
                        style={{ color: Colors.red }}
                        className={Styles.ErrorStyling}
                      >
                        {typeError.length > 0 ? (
                          <IFText style={{ fontSize: '0.75rem' }}>
                            {typeError}
                          </IFText>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                typedText || addedFile
                  ? [Styles.DividerWrapper, Styles.FadeOut].join(' ')
                  : [Styles.DividerWrapper, Styles.FadeIn].join(' ')
              }
            >
              <div className={Styles.DividerContainer}>
                <Divider />
              </div>
              <div className={Styles.DividerText}>
                <IFText style={{ color: Colors.text }}>
                  {t('AddChargingTokensModal.Or')}
                </IFText>
              </div>
              <div className={Styles.DividerContainer}>
                <Divider />
              </div>
            </div>

            <div className={typedText ? Styles.FadeOut : Styles.FadeIn}>
              <Dropzone
                multiple={false}
                onDrop={(acceptedFiles) => handleOnDrop(acceptedFiles)}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div
                        className={
                          addedFile ? Styles.DropZoneSelected : Styles.DropZone
                        }
                        style={{ backgroundColor: Colors.DropZoneBackground }}
                      >
                        {uploadedFile == null ? (
                          <>
                            <FileUploadIcon />

                            <IFText>
                              {t('AddChargingTokensModal.DragAndDrop')}
                            </IFText>
                          </>
                        ) : (
                          <>
                            <InsertDriveFileIcon fontSize="large" />
                            <div
                              className={Styles.CloseIconContainer}
                              onClick={(e) => {
                                e.stopPropagation()
                                setUploadedFile(null)
                                setAddedFile(false)

                                setCanContinue(false)
                              }}
                            >
                              <Icon
                                className={Styles.CloseIcon}
                                component={CancelIcon}
                              />
                            </div>
                            <IFText>{uploadedFile[0].name}</IFText>
                          </>
                        )}
                      </div>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>

            <div className={Styles.Submit}>
              <IFButton
                text={t('AddChargingTokensModal.Submit')}
                color={Colors.primary}
                isFill={true}
                isLoading={false}
                size="sm"
                onClick={() => handleSubmit()}
                isDead={!canContinue}
              ></IFButton>
            </div>
          </div>
        </div>
      </IFModal>
    )
  },
)

function mapDispatchToProps(dispatch) {
  return {
    addChargingTokens: (newCard) => dispatch(CardActions.addCard(newCard)),
    addChargingTokensBulk: (file) => dispatch(CardActions.addCardBulk(file)),
  }
}

const mapStateToProps = (state) => ({
  addChargingTokensRequestState: CardSelectors.getAddCardRequestState(state),
  operatorUser: AuthSelectors.getOperatorUser(state),
})

AddChargingTokens.propTypes = {
  addChargingTokens: PropTypes.func,
  addChargingTokensRequestState: PropTypes.number,
  addChargingTokensBulk: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(AddChargingTokens)
